import angular from 'angular';
import { CartService } from '../tn.cart/service.tn.cart';
import { IProjectSummary } from '../tn.common';
import { OrderRepository } from '../tn.common/providers/OrderRepository';
import { hasWebHostedLicenseList } from '../tn.licenses/has-license-type.filter/has-web-hosted-license-list';
import { LocalProjects } from '../tn.projects/local-projects.service/localProjects';
import { UserService } from '../tn.user/service.tn.user';

export default angular
    .module('tn.confirmation', ['tn.user', 'tn.cart', 'tn.licenses'])
    .controller(
        'tn.confirmation.controller.orderConfirmation',
        OrderConfirmation
    ).name;

OrderConfirmation.$inject = [
    '$scope',
    'order',
    'tn.user.service',
    'tn.cart.service',
    'tnLicenseListService',
    'localProjects',
    'orderRepository',
];

function OrderConfirmation(
    $scope,
    order,
    userService: UserService,
    cartService: CartService,
    licenseListService,
    localProjects: LocalProjects,
    orderRepository: OrderRepository
) {
    const vm = angular.extend(this, {
        projects: localProjects.getSummaries(),
        upgradeProjectStage: 0,
        updateProjects: updateProjects,
        user: userService.getUser(),
    });

    order.hasWebLicense = function () {
        return licenseListService.hasWebLicense(order.licenses);
    };
    order.hasDownloadLicense = function () {
        return licenseListService.hasDownloadLicense(order.licenses);
    };
    order.isInvoiced = function () {
        return cartService.isInvoiced(order);
    };
    vm.order = order;
    vm.hasWebLicenseSelfHosted = licenseListService.hasWebLicenseSelfHosted(
        order.licenses
    );
    // Exclude self hosted from the 'update your projects' section
    const webLicenses = hasWebHostedLicenseList(vm.order.licenses);
    if (webLicenses.length !== 0) {
        $scope.$watchCollection('vm.projects', function (projects: IProjectSummary[]) {
            if (projects.length === 0) {
                return;
            }
            if (
                webLicenses.some((license) =>
                    projects.some((project) =>
                        project.styles.includes(license.style.id)
                    )
                )
            ) {
                vm.upgradeProjectStage = 1;
            }
        });
    }

    function updateProjects() {
        // Prevent multiple submissions
        if (vm.upgradeProjectStage !== 1) {
            return;
        }
        vm.upgradeProjectStage = 2;
        orderRepository
            .updateProjects(vm.order.id)
            .then(() => {
                vm.upgradeProjectStage = 3;
            })
            .catch(() => {
                vm.upgradeProjectStage = 4;
            });
    }
}
